export default function (str) {
  if (!str) return '';
  str = str
    .replace(/&/g, '&amp;')
    .replace(/>/g, '&gt;')
    .replace(/</g, '&lt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&rsquo;')
    .replace(/#/g, '&eparsl;')
    .replace(/`/g, '&rsquo;');
  return str;
}
